<template>
  <CustomModal :show-modal="isProgressSetting" title="Kết nối Hola HIS" @hideModal="closeModal">
    <div class="flex flex-col items-center justify-center h-full">
      <template v-if="isEHCConnected">
        <div class="text-3xl">🎉</div>
        <div class="mt-3 font-bold text-xl">Kết nối Hola HIS thành công</div>
      </template>
      <template v-else>
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="mt-3 robo-16-400">Vui lòng chờ trong giây lát...</div>
      </template>
      <div class="mt-3 robo-16-400">
        <i v-if="isSystemConnected" class="el-icon-success text-green-600 text-lg mr-1"></i>
        <i v-else-if="isSystemProgressing" class="el-icon-loading text-blue-600 text-lg mr-1"></i>
        <i v-else-if="isSystemConnectError" class="el-icon-error text-red-600 text-lg mr-1"></i>
        <i v-else class="el-icon-circle-check text-gray-600 text-lg mr-1"></i>
        <span>Kết nối hệ thống</span>
      </div>
      <div class="mt-3 robo-16-400">
        <i v-if="isWorkspaceConnected" class="el-icon-success text-green-600 text-lg mr-1"></i>
        <i v-else-if="isWorkspaceConnecting" class="el-icon-loading text-blue-600 text-lg mr-1"></i>
        <i v-else-if="isWorkspaceConnectError" class="el-icon-error text-red-600 text-lg mr-1"></i>
        <i v-else class="el-icon-circle-check text-gray-600 text-lg mr-1"></i>
        <span>Kết nối workspace</span>
      </div>
      <div class="mt-3 robo-16-400">
        <i v-if="isPatientsSynced" class="el-icon-success text-green-600 text-lg mr-1"></i>
        <i v-else-if="isPatientsSyncing" class="el-icon-loading text-blue-600 text-lg mr-1"></i>
        <i v-else-if="isPatientsSyncError" class="el-icon-error text-red-600 text-lg mr-1"></i>
        <i v-else class="el-icon-circle-check text-gray-600 text-lg mr-1"></i>
        <span>Đồng bộ bệnh nhân</span>
      </div>
      <div class="mt-3 robo-16-400">
        <i v-if="isServicesSynced" class="el-icon-success text-green-600 text-lg mr-1"></i>
        <i v-else-if="isServicesSyncing" class="el-icon-loading text-blue-600 text-lg mr-1"></i>
        <i v-else-if="isServicesSyncError" class="el-icon-error text-red-600 text-lg mr-1"></i>
        <i v-else class="el-icon-circle-check text-gray-600 text-lg mr-1"></i>
        <span>Đồng bộ dịch vụ</span>
      </div>
      <div class="mt-3 robo-16-400">
        <i v-if="isPEsSynced" class="el-icon-success text-green-600 text-lg mr-1"></i>
        <i v-else-if="isPEsSyncing" class="el-icon-loading text-blue-600 text-lg mr-1"></i>
        <i v-else-if="isPEsSyncError" class="el-icon-error text-red-600 text-lg mr-1"></i>
        <i v-else class="el-icon-circle-check text-gray-600 text-lg mr-1"></i>
        <span>Đồng bộ lịch khám</span>
      </div>
      <div class="mt-3 robo-16-400">
        <i v-if="isPMRSynced" class="el-icon-success text-green-600 text-lg mr-1"></i>
        <i v-else-if="isPMRSyncing" class="el-icon-loading text-blue-600 text-lg mr-1"></i>
        <i v-else-if="isPMRSyncError" class="el-icon-error text-red-600 text-lg mr-1"></i>
        <i v-else class="el-icon-circle-check text-gray-600 text-lg mr-1"></i>
        <span>Đồng bộ bệnh án</span>
      </div>
    </div>
  </CustomModal>
</template>
<script>
import CustomModal from '@components/CustomModal/index.vue'
import EHCSyncRequest from '@/api/request/EHCSyncRequest'

const api = new EHCSyncRequest()

export default {
  name: 'EHCProgressConnect',
  components: { CustomModal },
  props: {
    isProgressSetting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEHCConnected: false,
      isSystemConnected: false,
      isSystemConnectError: null,
      isSystemProgressing: false,
      isWorkspaceConnected: false,
      isWorkspaceConnectError: null,
      isWorkspaceConnecting: false,
      isPatientsSynced: false,
      isPatientsSyncError: null,
      isPatientsSyncing: false,
      isServicesSynced: false,
      isServicesSyncError: null,
      isServicesSyncing: false,
      isPEsSynced: false,
      isPEsSyncError: null,
      isPEsSyncing: false,
      isPMRSynced: false,
      isPMRSyncError: null,
      isPMRSyncing: false
    }
  },
  watch: {
    isProgressSetting: {
      immediate: true,
      deep: true,
      handler (newVal) {
        if (newVal) {
          this.startEHCConnect()
        }
      }
    }
  },
  methods: {
    async startEHCConnect () {
      await this.EHCSystemConnect()
      await this.EHCWorkspaceConnect()
      await this.EHCSyncPatients()
      await this.EHCSyncServices()
      await this.EHCSyncPatientExaminations()
      await this.EHCSyncPatientMedicalRecords()
      this.$emit('ehcConnectComplete')
      this.isEHCConnected = true
    },
    closeModal () {
      if (this.isEHCConnected) {
        this.$emit('hideModal')
      }
    },
    async EHCSystemConnect () {
      try {
        this.isSystemProgressing = true
        await api.ehcSystemLogin()
        // this.$toast.open({ message: 'Đăng nhập hệ thống Hola HIS thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isSystemConnected = true
        this.isSystemConnectError = null
      } catch (err) {
        // this.$toast.open({ message: 'Lỗi đăng nhập hệ thống Hola HIS.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('System login exception:', err)
        this.isSystemConnectError = err?.response
      } finally {
        this.isSystemProgressing = false
      }
    },
    async EHCWorkspaceConnect () {
      try {
        this.isWorkspaceConnecting = true
        let orgId = this.$globalOrg?.id || this.$globalClinic?.organization?.id || this.$user?.members[0]?.org_id || null
        await api.ehcWorkspaceConnect({ org_id: orgId })
        // this.$toast.open({ message: 'Kết nối workspace Hola HIS thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isWorkspaceConnected = true
        this.isWorkspaceConnectError = null
      } catch (err) {
        // this.$toast.open({ message: 'Lỗi kết nối workspace Hola HIS.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('Workspace connect exception:', err)
        this.isWorkspaceConnectError = err?.response
      } finally {
        this.isWorkspaceConnecting = false
      }
    },
    async EHCSyncPatients () {
      try {
        this.isPatientsSyncing = true
        await api.ehcSyncPatient({})
        // this.$toast.open({ message: 'Đồng bộ bệnh nhân Hola HIS thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isPatientsSynced = true
        this.isPatientsSyncError = null
      } catch (err) {
        // this.$toast.open({ message: 'Lỗi đồng bộ bệnh nhân Hola HIS.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('Sync patient exception:', err)
        this.isPatientsSyncError = err?.response
      } finally {
        this.isPatientsSyncing = false
      }
    },
    async EHCSyncServices () {
      try {
        this.isServicesSyncing = true
        await api.ehcSyncServices()
        // this.$toast.open({ message: 'Đồng bộ dịch vụ Hola HIS thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isServicesSynced = true
        this.isServicesSyncError = null
      } catch (err) {
        // this.$toast.open({ message: 'Lỗi đồng bộ dịch vụ Hola HIS.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('Sync services exception:', err)
        this.isServicesSyncError = err?.response
      } finally {
        this.isServicesSyncing = false
      }
    },
    async EHCSyncPatientExaminations () {
      try {
        this.isPEsSyncing = true
        await api.ehcSyncPatientExaminations({ patient_id: 0, clinic_id: 0 })
        // this.$toast.open({ message: 'Đồng bộ khám bệnh Hola HIS thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isPEsSynced = true
        this.isPEsSyncError = null
      } catch (err) {
        // this.$toast.open({ message: 'Lỗi đồng bộ khám bệnh Hola HIS.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('Sync PE exception:', err)
        this.isPEsSyncError = err?.response
      } finally {
        this.isPEsSyncing = false
      }
    },
    async EHCSyncPatientMedicalRecords () {
      try {
        this.isPMRSyncing = true
        await api.ehcSyncPatientMedicalRecords({ patient_id: 0, clinic_id: 0 })
        // this.$toast.open({ message: 'Đồng bộ hồ sơ bệnh án Hola HIS thành công!', type: 'success', position: 'top-right', duration: 3000 })
        this.isPMRSynced = true
        this.isPMRSyncError = null
      } catch (err) {
        // this.$toast.open({ message: 'Lỗi đồng bộ hồ sơ bệnh án Hola HIS.', type: 'error', position: 'top-right', duration: 5000 })
        console.error('Sync PMR exception:', err)
        this.isPMRSyncError = err?.response
      } finally {
        this.isPMRSyncing = false
      }
    }
  }
}
</script>
